import { useContext } from 'react';
import { SyntheticEvent } from 'react';
import { Search } from 'react-feather';
import { makeStyles } from 'tss-react/mui';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import { ITechPack } from '../../../../common/interfaces';
import TechPackSearchItem from './TechPackSearchItem';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';
import TechPacksConext from '../../../../contexts/TechPacksContext';

const useStyles = makeStyles()((theme) => ({
	techPacksAutocompleteContainer: {},
	autoCompleteListBox: {
		padding: '0',
	},
	renderOptionLi: {
		background: 'transparent',
		'&:hover': {
			background: 'transparent',
		},
	},
}));

interface IProps {
	options: ITechPack[];
	className: string;
}

const ImportTechPackAutoComplete = ({ options, className }: IProps) => {
	const { classes } = useStyles();
	const techPacksApi = useContext(TechPacksConext);
	const { setSelectedTechPacks } = techPacksApi;

	return (
		<Autocomplete
			id="import-tech-packs-autocomplete"
			options={options}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			getOptionLabel={(option) => option.name || ''}
			className={`${classes.techPacksAutocompleteContainer} ${className}`}
			classes={{
				listbox: `${classes.autoCompleteListBox}`,
			}}
			onChange={(
				event: SyntheticEvent,
				selectedTechPack: ITechPack | null
			) => {
				if (setSelectedTechPacks && selectedTechPack) {
					setSelectedTechPacks([selectedTechPack as ITechPack]);
				} else if (setSelectedTechPacks) {
					setSelectedTechPacks([]);
				}
			}}
			renderOption={(props, option) => (
				<li
					{...props}
					key={option.id}
					className={classes.renderOptionLi}
				>
					<TechPackSearchItem techPack={option} />
					<Divider />
				</li>
			)}
			renderInput={(params) => {
				return (
					<TextField
						{...params}
						placeholder="E.g. Packable Jacket"
						label="Search for Tech Pack"
						InputProps={{
							...params.InputProps,
							type: 'text',
							startAdornment: (
								<InputAdornment position="start">
									<Search />
								</InputAdornment>
							),
						}}
					/>
				);
			}}
		/>
	);
};

export default ImportTechPackAutoComplete;
